import React from "react";
import PropTypes from 'prop-types';
import ReactDOM from "react-dom";
import { connect } from 'react-redux';

import { SetCarpetaDocDocumentoEnAPI, GetCarpetaDocEnAPI, GetCarpetaDocDocumentoEnAPI, SetCarpetaDocEnAPI, GetSociosExcluidosCarpetaEnAPI, GetSociosExcluidosDocumentoEnAPI, ObtenerEndPoint } from "../../action/actionCreatorsRequests";
import {
    MSGOK, recortarCadena, obtenerUsuario, obtenerToken, traducirPagina, MSGERROR

} from "../../librerias/funciones"

import VisorGenerico from "../VisorGenerico";

import { Button, Modal, Row, Col } from 'antd';
import {
    RightOutlined
} from '@ant-design/icons';



const MantenimientoDocumentacion = ({ }) => {
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)

    const [loaderDescargaDocumento, setLoaderDescargaDocumento] = React.useState({
        LOADER: false,
        ID_DOCUMENTO: 0
    });

    const [modalBajaVisible, setModalBajaVisible] = React.useState({
        ABRIR_MODAL: false,
        ID: 0,
        ID_PADRE: 0,
        NOMBRE: "",
        ES_DOCUMENTO: false
    });



    const [abrirVisor, setAbrirVisor] = React.useState(false);
    const [ficheroSeleccionado, setFicheroSeleccionado] = React.useState({});
    const [registroIDS, setregistroIDS] = React.useState({});


    const [licencias, setLicencias] = React.useState([]);
    const [ruta, setRuta] = React.useState([]);
    const [registroExcluir, setRegistroExcluir] = React.useState([]);



    const licenciasSertec = (ORDERCOLUM, ORDERDIR, ID) => {
        setLicencias([]);

        GetCarpetaDocEnAPI(ORDERCOLUM, ORDERDIR, ID).then((licencias) => {
            if (licencias !== undefined && licencias !== null) {

                const RAIZ_CARPETA = licencias.CARPETA === null ? {} : licencias.CARPETA[0]
                const CARPETAS = licencias.CARPETAS
                setregistroIDS({ ID_PADRE: (RAIZ_CARPETA.ID_PADRE), ID: RAIZ_CARPETA.ID, OPCION: 2 })


                if (ruta.length === 0) {
                    let ACTUALIZAR_RUTA = [...ruta, RAIZ_CARPETA]
                    setRuta(ACTUALIZAR_RUTA)
                }

                setLicencias(CARPETAS);
            } else {
                setLicencias(null)
            }
        })
    }



    const GetSociosExcluidosCarpeta = async (ORDERCOLUM, ORDERDIR, ID, ID_CARPETA, ID_SOCIO) => {
        const registros = await GetSociosExcluidosCarpetaEnAPI(ORDERCOLUM, ORDERDIR, ID, ID_CARPETA, ID_SOCIO)

        if (registros !== undefined && registros !== null && registros.REGISTROS !== null && registros.REGISTROS.length > 0) {
            const registroSocios = registros.REGISTROS;
            registroExcluir.push(...registroSocios)

            setRegistroExcluir(registroExcluir)
        }


        GetSociosExcluidosDocumento(ORDERCOLUM, ORDERDIR, ID, ID_CARPETA, null, ID_SOCIO)

        return registros;

    }


    const GetSociosExcluidosDocumento = async (ORDERCOLUM, ORDERDIR, ID, ID_CARPETA, ID_DOCUMENTO, ID_SOCIO) => {
        const registros = await GetSociosExcluidosDocumentoEnAPI(ORDERCOLUM, ORDERDIR, ID, ID_CARPETA, ID_DOCUMENTO, ID_SOCIO)

        if (registros !== undefined && registros !== null && registros.REGISTROS !== null && registros.REGISTROS.length > 0) {
            const registroSocios = registros.REGISTROS;
            registroExcluir.push(...registroSocios)

            setRegistroExcluir(registroExcluir)
        }



        licenciasSertec(1, "A", 1, 1);

        return registros;
    }



    const obtenerImagenPorExtension = (EXTENSION) => {
        EXTENSION = EXTENSION.toUpperCase();
        let resultado = "";

        switch (EXTENSION) {
            case "PNG": case "JPG": case "JPEG": case "GIF":
                resultado = "imagen.png";
                break;
            case "PDF":
                resultado = "pdf.png";
                break;
            case "XLSX": case "XLS": case "XLSM": case "XLSB": case "XLTX": case "CSV":
                resultado = "excel.png"
                break;
            case "DOCX":
                resultado = "word.png"
                break;
            case "MP4": case "MOV": case "WMV": case "MKV":
                resultado = "video.png"
                break;
            case "ZIP": case "RAR":
                resultado = "comprimido.png"
                break;
            default:
                resultado = "generico.png"
                break;

        }
        return resultado;
    }


    const obtenerDocumento = (ORDERCOLUM, ORDERDIR, ID, REGISTRO) => {
        setFicheroSeleccionado({})

        const { ID_DOCUMENTO, EXTENSION, NOMBRE } = REGISTRO;
        console.log("DATA", REGISTRO)
        const TIPO = obtenerImagenPorExtension(EXTENSION);

        if (TIPO !== "imagen.png" || TIPO !== "pdf.png") {
            loaderDescargaDocumento.ID_DOCUMENTO = ID_DOCUMENTO
            loaderDescargaDocumento.LOADER = true
            setLoaderDescargaDocumento({ ...loaderDescargaDocumento })

            setFicheroSeleccionado({ TITULO: NOMBRE === undefined || NOMBRE === null ? "VISTA PREVIA" : NOMBRE, TIPO_DOCUMENTO: TIPO === "imagen.png" ? "IMG" : "DOC", URL: `${ObtenerEndPoint()}api/NextGroup/VisualizarDocumento/${ID}/${window.btoa(obtenerToken())}`, FICHERO: {}, ID: ID })

            console.log("Visor documento",`${ObtenerEndPoint()}api/NextGroup/VisualizarDocumento/${ID}/${window.btoa(obtenerToken())}`)
            setAbrirVisor(true)
        } else {
            //DESCARGAR
            window.open(`${ObtenerEndPoint()}api/NextGroup/DescargaCarpetaDocDocumento/${ID}/${window.btoa(obtenerToken())}`, '_blank').focus();

            console.log("Previa documento",`${ObtenerEndPoint()}api/NextGroup/DescargaCarpetaDocDocumento/${ID}/${window.btoa(obtenerToken())}`)
        }

        loaderDescargaDocumento.ID_DOCUMENTO = 0
        loaderDescargaDocumento.LOADER = false
        setLoaderDescargaDocumento({ ...loaderDescargaDocumento })

    }




    const DarDeBajaCarpeta = (ID, ID_PADRE, ES_DOCUMENTO) => {
        if (ES_DOCUMENTO) {
            SetCarpetaDocDocumentoEnAPI(2, ID, ID_PADRE).then((registro) => {
                if (registro.OK) {
                    licenciasSertec(1, "A", registroIDS.ID);
                }
            })
        } else {
            SetCarpetaDocEnAPI(2, ID, ID_PADRE, "").then((registro) => {
                if (registro.OK) {
                    licenciasSertec(1, "A", registroIDS.ID);
                }
            })
        }
    }


    const ocultarCarpeta = (REGISTRO) => {
        let ocultarCarpeta = false;
        if (obtenerUsuario().SOCIOS.length === 1) {
            const { ES_DOCUMENTO, ID, ID_DOCUMENTO } = REGISTRO
            let SOCIO_LOCAL = obtenerUsuario().SOCIOS[0].ID_SOCIO

            if (ES_DOCUMENTO) {
                let BUSCAR_SOCIO = registroExcluir.find((registro) => registro.ID_DOCUMENTO === ID_DOCUMENTO && registro.ID_SOCIO_EXCLUIDO === SOCIO_LOCAL)
                if (BUSCAR_SOCIO !== undefined) {
                    ocultarCarpeta = true
                }

            } else {
                let BUSCAR_SOCIO = registroExcluir.find((registro) => registro.ID_CARPETA === ID && registro.ID_SOCIO_EXCLUIDO === SOCIO_LOCAL && registro.ID_DOCUMENTO === undefined)
                if (BUSCAR_SOCIO !== undefined) {
                    ocultarCarpeta = true
                }
            }
        }

        return ocultarCarpeta
    }

    const descargarFichero = (ID) => {
        window.open(`${ObtenerEndPoint()}api/NextGroup/DescargaCarpetaDocDocumento/${ID}/${window.btoa(obtenerToken())}`, '_blank').focus();

    }

    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }


    })


    React.useEffect(() => {
        if (obtenerToken() !== undefined) {
            GetSociosExcluidosCarpeta(1, "A", null, null, null)
        }
    }, [])



    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {traducirPagina("DOCUMENTOS_GRUPO").toUpperCase()}
        </>,
        document.getElementById("tituloMenu")
    );


    return (
        <>
            <div className="container_ruta" style={ruta === null || ruta.length === 0 ? { height: '44px' } : {}} ref={ref}>
                {ruta.map((registro) =>
                    <>
                        <div onClick={() => {
                            if (registro.NOMBRE !== ruta[ruta.length - 1].NOMBRE) {
                                licenciasSertec(1, "A", registro.ID, 2);
                                let NUEVA_RUTA = [];
                                for (let i = 0; i < ruta.length; i++) {
                                    NUEVA_RUTA.push(ruta[i])
                                    if (registro.ID === ruta[i].ID) {
                                        break;
                                    }
                                }
                                setRuta([...NUEVA_RUTA])
                            }
                        }}>{recortarCadena(registro.NOMBRE, 20, " ...")}</div>

                        <div className="icono_separador"><RightOutlined></RightOutlined></div>
                    </>
                )}
            </div>


            <div className={"containerGestorDoc"} style={{ height: `calc(100vh - ${(120 + alturaSubmenu)}px )` }}>

                {licencias === null ?
                    <div className="centrar_contenedor" style={{ textAlign: 'center' }}>
                        <h4>{traducirPagina("Sin_resultados")}</h4>
                    </div>
                    :
                    licencias.length > 0 ?
                        <div className="container_doc_folder" >

                            {licencias.map((registro, i) => (
                                ocultarCarpeta(registro) ?
                                    null
                                    :
                                    <div className="item_folder">
                                        <div className="body_folder"
                                            style={{
                                                backgroundImage: `url(${"./imagenes/iconos/"}${(registro.ES_DOCUMENTO ? obtenerImagenPorExtension(registro.EXTENSION) : "empty_folder.png")})`,
                                                backgroundSize: !registro.ES_DOCUMENTO && "50%"
                                            }}
                                            onClick={(e) => {
                                                const BTN = Object.keys(e.target.dataset).length > 0 ? e.target.dataset.icon : ""
                                                const BOTON_ELIMINAR = e.target.ariaLabel

                                                if (BOTON_ELIMINAR === "delete" || BTN === "delete" || BOTON_ELIMINAR === "copy" || BTN === "copy" || BOTON_ELIMINAR === "diff" || BTN === "diff" || BOTON_ELIMINAR === "unordered-list" || BTN === "unordered-list") {
                                                    //alert("CLICK EN BOTON ELIMINAR")
                                                } else {

                                                    if (e.target.parentElement.nodeName === "DIV") {
                                                        if (registro.ES_DOCUMENTO) {
                                                            obtenerDocumento(1, "A", registro.ID, registro)
                                                        } else {
                                                            let ACTUALIZAR_RUTA = [...ruta, registro]
                                                            setRuta(ACTUALIZAR_RUTA)
                                                            licenciasSertec(1, "A", registro.ID, 2);
                                                        }
                                                    }
                                                }
                                            }}
                                        >


                                            {loaderDescargaDocumento.LOADER && loaderDescargaDocumento.ID_DOCUMENTO === registro.ID_DOCUMENTO ?
                                                <div className="image-mask" style={{ opacity: '1' }}>
                                                    <div className="image-mask-info">
                                                        {`${traducirPagina("Visualizando")} ...`}
                                                    </div>
                                                </div>
                                                :
                                                null
                                            }
                                        </div>

                                        <div className="folder_footer">
                                            {registro.NOMBRE}
                                        </div>
                                    </div>

                            ))}
                        </div>
                        :
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                }
            </div>






            {abrirVisor ?
                <VisorGenerico
                    title={""}
                    ABRIR_VISOR={abrirVisor}
                    CERRAR_VISOR={setAbrirVisor}

                    PROPIEDADES_DOC={ficheroSeleccionado}
                    MOSTRAR_BOTON_DESCARGA={true}
                    EVENTO_DESCARGA={descargarFichero}
                >
                </VisorGenerico>
                :
                null
            }




            {modalBajaVisible.ABRIR_MODAL ?
                <Modal
                    visible={modalBajaVisible.ABRIR_MODAL}
                    width={600}
                    centered
                    title={traducirPagina("Dar_baja")}
                    afterClose={() => {
                        modalBajaVisible.ABRIR_MODAL = false
                        modalBajaVisible.ID = 0
                        modalBajaVisible.ID_PADRE = 0
                        modalBajaVisible.NOMBRE = ""
                        modalBajaVisible.ES_DOCUMENTO = false
                        setModalBajaVisible({ ...modalBajaVisible })
                    }}
                    onCancel={() => { modalBajaVisible.ABRIR_MODAL = false; setModalBajaVisible({ ...modalBajaVisible }) }}
                    style={{ zIndex: '99999999' }}
                    footer={[
                        <Button key="back" onClick={() => { modalBajaVisible.ABRIR_MODAL = false; setModalBajaVisible({ ...modalBajaVisible }) }}>
                            NO
                        </Button>,
                        <Button style={{ backgroundColor: '#000' }} key="submit" type="primary" onClick={() => {

                            DarDeBajaCarpeta(modalBajaVisible.ID, modalBajaVisible.ID_PADRE, modalBajaVisible.ES_DOCUMENTO);


                            modalBajaVisible.ABRIR_MODAL = false;
                            setModalBajaVisible({ ...modalBajaVisible })

                        }}> SI</Button>
                    ]}
                >
                    <Row>
                        <Col md={24} className="mt-2 mb-2">
                            {modalBajaVisible.ES_DOCUMENTO ?
                                <span className="tituloRecuperarEmail">{`¿Esta seguro de querer eliminar este documento?`} </span>

                                :
                                <span className="tituloRecuperarEmail">{`¿Esta seguro de querer eliminar la carpeta y todo su contenido?`} </span>

                            }
                        </Col>

                    </Row>
                </Modal>
                : null

            }
        </>
    );
}


MantenimientoDocumentacion.propTypes = {
    EVENTO_MENU: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        search: state.searchValue,
        configApp: state.configApp,
        usuario: state.usuario,
        clienteSeleccionado: state.clienteSeleccionado,
        activeItemReferencia: state.activeItemReferencia,

    };
}

export default connect(mapStateToProps)(MantenimientoDocumentacion);
